'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastSeenFailure = exports.lastSeenSuccess = exports.lastSeenSent = undefined;
exports.markLastMessageReadByVisitor = markLastMessageReadByVisitor;

var _reduxActions = require('redux-actions');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _silenceErrorAlert = require('conversations-error-reporting/error-actions/builders/silenceErrorAlert');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _markMessageReadByVisitor = require('../../threads/clients/markMessageReadByVisitor');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _postClearPageTitleNotification = require('../../page-title-notifications/actions/post-message/postClearPageTitleNotification');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var lastSeenSent = exports.lastSeenSent = (0, _reduxActions.createAction)(ActionTypes.LAST_SEEN_SENT);
var lastSeenSuccess = exports.lastSeenSuccess = (0, _reduxActions.createAction)(ActionTypes.LAST_SEEN_SUCCESS);
var lastSeenFailure = exports.lastSeenFailure = (0, _reduxActions.createAction)(ActionTypes.LAST_SEEN_FAILURE, function (_ref) {
  var error = _ref.error;
  return { error: error };
}, _silenceErrorAlert.silenceErrorAlert);

function markLastMessageReadByVisitor(_ref2) {
  var conversation = _ref2.conversation;

  return function (dispatch, getState) {
    var threadId = (0, _threadGetters.getThreadId)(conversation);
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var latestMessage = (0, _threadGetters.getLatestMessage)(conversation);
    var latestSentReadTimestamp = (0, _threadGetters.getLatestReadTimestamp)(conversation);
    var latestMessageTimestamp = (0, _commonMessageFormatGetters.getTimestamp)(latestMessage);
    if (latestMessageTimestamp && threadId && sessionId) {
      if (latestMessageTimestamp > latestSentReadTimestamp) {
        var channel = (0, _threadGetters.getChannel)(conversation);
        var payload = {
          role: _senderTypes.VISITOR,
          threadId: threadId,
          channel: channel,
          latestMessageTimestamp: latestMessageTimestamp
        };
        dispatch(lastSeenSent(payload));
        (0, _markMessageReadByVisitor.markMessageReadByVisitor)({
          message: latestMessage,
          threadId: threadId,
          sessionId: sessionId
        }).then(function () {
          dispatch(lastSeenSuccess(payload));
          dispatch((0, _postClearPageTitleNotification.postClearPageTitleNotification)());
        }).catch(function (error) {
          dispatch(lastSeenFailure({ error: error }));
        }).done();
      }
    }
  };
}